__turbopack_context__.v({
  "header_column": "ProductHeader-module-scss-module__xLYG3q__header_column",
});
